import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { initSentry } from './app/core/sentry';
import { dispatchChunkLoadFailureEvent } from './app/core/utils/chunk-load-error.util';
import { getErrorMessageFromUnknown, messageLooksLikeChunkLoadFailure } from './app/shared/helpers';
import { environment } from './environments/environment';

initSentry(environment);

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.error(err);
  const message = getErrorMessageFromUnknown(err);
  if (messageLooksLikeChunkLoadFailure(message)) {
    dispatchChunkLoadFailureEvent();
  }
});
